import { render } from "./leads-dashboard.vue?vue&type=template&id=3613586a"
import script from "./leads-dashboard.vue?vue&type=script&lang=js"
export * from "./leads-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__